import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: ${({ show }) => (show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background-color: #1a1a1a;
  width: 900px;
  max-width: 95%;
  display: flex;
  flex-direction: row-reverse;
  overflow: hidden;
  position: relative;
  min-height: 360px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    min-height: 420px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 34px;
  height: 34px;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.04);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  cursor: pointer;
  color: #f16024;
  z-index: 30;

  &:hover {
    background: #222;
  }
`;

export const ModalLeft = styled.div`
  width: 30%;
  min-height: 360px;

  @media (max-width: 768px) {
    width: 100%;
    min-height: 200px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ModalRight = styled.div`
  width: 70%;
  padding: 1.5rem 2rem 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: #fff;
  z-index: 5;

  @media (max-width: 768px) {
    width: 100%;
    padding: 1rem 1rem 2rem;
  }
`;

export const Title = styled.h2`
  color: #f16024;
  font-size: 72px;
  line-height: 1.1;
  margin: 0 0 6px 0;
  font-weight: 300;
`;

export const Subtitle = styled.h3`
  color: #f16024;
  font-size: 1.3rem;
  margin: 0 0 10px 0;
  font-weight: 400;
`;

export const Paragraph = styled.p`
  font-family: 'Open Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 28px;
  margin: 14px 0 8px 0;
  color: #c3c3c3;

  span {
    color: #f16024;
`;

export const FloatingButtons = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 25;
  pointer-events: auto;
  padding: 16px 20px;
  border-radius: 0 0 10px 10px;

  @media (max-width: 768px) {
    bottom: 40px;
    padding: 12px 14px;
  }
`;

export const Button = styled.a`
  display: inline-block;
  text-align: center;
  padding: 12px 20px;
  margin: 6px 0;
  width: min(640px, 92%);
  background-color: ${({ primary }) => (primary ? '#f16024' : 'transparent')};
  color: ${({ primary }) => (primary ? '#F6F6F6' : '#FACAB6')};
  text-decoration: none;
  cursor: pointer;
  font-family: Barlow;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  line-height: 32px;
  border: ${({ primary }) => (primary ? 'none' : 'none')};

  &:hover {
    background-color: ${({ primary }) => (primary ? '#d44e1b' : 'none')};
  }
`;
